import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-property',
  templateUrl: './change-property.component.html',
  styleUrls: ['./change-property.component.css']
})
export class ChangePropertyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/change-property/change-property.component.ts